import {useQuery} from "@tanstack/react-query";
import getNinetyDaysLeaderboard from "../api/getNinetyDaysLeaderboard";

const useGetNinetyDaysLeaderboard = () => {
  const {
    data: dataNinetyDaysLeaderboard,
    isLoading: NinetyLeaderboardIsLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["getNinetyDaysLeaderboard"],
    queryFn: getNinetyDaysLeaderboard,
  });

  return {
    dataNinetyDaysLeaderboard,
    NinetyLeaderboardIsLoading,
    isError,
    error,
  };
};

export default useGetNinetyDaysLeaderboard;
